<template>
<div class="card">
  <div class="card-header">
    <button @click="() => open = !open" class="btn" type="button" data-toggle="collapse" data-target="#userFiltersCollapseCollapse" aria-expanded="false" aria-controls="userFiltersCollapseCollapse">
      <i v-if="open" class="fas fa-angle-up"></i>
      <i v-else class="fas fa-angle-down"></i>
      <h4 data-target="#userFiltersCollapseCollapse" aria-expanded="false" aria-controls="userFiltersCollapseCollapse" class="btn alert-heading font-18 text-dark">Իմ ֆիլտրները</h4>
    </button>
  </div>
  <div id="userFiltersCollapseCollapse" class="collapse multi-collapse">
    <div class="card-body d-flex flex-column">
      <div class="row">
        <div class="col-lg-3 mb-2">
          <multiselect
            v-model="filters.type"
            :options="filters.typeOptions"
            label="name"
            track-by="value"
            :searchable="false"
            :close-on-select="false"
            :show-labels="true"
            selectLabel="Սեղմեք ընտրելու համար"
            deselectLabel="Սեղմեք հեռացնելու համար"
            selectedLabel="Ընտրված է"
            :multiple="false"
            placeholder="Տեսակ"
          />
        </div>
        <div class="col-lg-3 mb-2">
          <multiselect
            v-model="filters.status"
            :options="filters.statusOptions"
            label="name"
            track-by="value"
            :searchable="false"
            :close-on-select="false"
            :allow-empty="true"
            :show-labels="true"
            selectLabel="Սեղմեք ընտրելու համար"
            deselectLabel="Սեղմեք հեռացնելու համար"
            selectedLabel="Ընտրված է"
            placeholder="Կարգավիճակ"
          />
        </div>
        <div class="col-lg-3 mb-2">
          <multiselect
            v-if="filters.type != 'ՀՀ֊ից դուրս մրցույթներ'"
            v-model="filters.region"
            track-by="name"
            label="name"
            :options="filters.regionOptions"
            :searchable="false"
            :close-on-select="false"
            :show-labels="true"
            selectLabel="Սեղմեք ընտրելու համար"
            deselectLabel="Սեղմեք հեռացնելու համար"
            selectedLabel="Ընտրված է"
            :multiple="true"
            placeholder="Տարածաշրջան"
          />
        </div>
        <div class="col-lg-3 mb-2">
          <multiselect
            v-model="filters.organizator"
            track-by="name"
            label="name"
            :options="filters.organizatorOptions"
            :searchable="true"
            :close-on-select="false"
            :show-labels="true"
            selectLabel="Սեղմեք ընտրելու համար"
            deselectLabel="Սեղմեք հեռացնելու համար"
            selectedLabel="Ընտրված է"
            :multiple="true"
            placeholder="Պատվիրատու"
          />
        </div>
        <div class="col-lg-3 mb-2">
            <multiselect
              v-model="filters.guaranteed"
              :options="filters.guaranteedOptions"
              label="name"
              track-by="value"
              :searchable="false"
              :close-on-select="false"
              :show-labels="true"
              selectLabel="Սեղմեք ընտրելու համար"
              deselectLabel="Սեղմեք հեռացնելու համար"
              selectedLabel="Ընտրված է"
              placeholder="Երաշխիք"
            />
          </div>
        <template v-if="filters.type && filters.type.value === 'competitive'" >
          <div class="col-lg-3 mb-2">
            <multiselect
              class="mySelect"
              v-model="filters.isElectronic"
              :options="filters.isElectronicOptions"
              label="name"
              track-by="value"
              :searchable="false"
              :close-on-select="false"
              :show-labels="true"
              selectLabel="Սեղմեք ընտրելու համար"
              deselectLabel="Սեղմեք հեռացնելու համար"
              selectedLabel="Ընտրված է"
              :allow-empty="true"
              placeholder="Էլեկտրոնային / թղթային"
            />
          </div>
          <div class="col-lg-3 mb-2">
            <multiselect
              v-model="filters.procedure"
              :options="filters.procedureOptions"
              label="contact"
              track-by="id"
              :searchable="false"
              :close-on-select="false"
              :show-labels="true"
              selectLabel="Սեղմեք ընտրելու համար"
              deselectLabel="Սեղմեք հեռացնելու համար"
              selectedLabel="Ընտրված է"
              :multiple="true"
              placeholder="Ընթացակարգի տեսակ"
            />
          </div>
        </template>
        <div class="col-12 mt-3">
          <button @click="save" type="button" class="btn btn-primary  waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
              Պահպանել
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'userFilters',
  data () {
    return {
      isInvalidPhone: false,
      type: 'legalEntity',
      open: false,
      filters: {
        status: null,
        statusOptions: [
          { name: 'Բոլորը', value: 'all' },
          { name: 'Ակտիվ մրցույթներ', value: 'active' },
          { name: 'Ավարտված մրցույթներ', value: 'finished' },
        ],
        type: null,
        typeOptions: [
          { name: 'Պետական մրցակցային մրցույթներ', value: 'competitive' },
          { name: 'Պետական մեկ անձի մրցույթներ', value: 'one_person' },
          { name: 'Մասնավոր մրցույթներ', value: 'private' },
          { name: 'ՀՀ֊ից դուրս մրցույթներ', value: 'international' },
        ],
        isElectronic: null,
        isElectronicOptions: [
          { name: 'Թղթային', value: false },
          { name: 'Էլեկտրոնային', value: true },
        ],
        procedure: [],
        procedureOptions: [
          { name: 'ԳՀ', value: 'GH' },
          { name: 'ԲՄ', value: 'BM' },
          { name: 'ՀԲՄ', value: 'UBA' },
          { name: 'ՀՄԱ', value: 'HMA' },
        ],
        region: [],
        regionOptions: [],
        organizator: [],
        organizatorOptions: [],
        guaranteed: null,
        guaranteedOptions: [
          { name: 'Երաշխիքով', value: true },
          { name: 'Առանց երաշխիքի', value: false },
        ],
      },
      userType: this.$route.params.type,
      isPrivate: this.$route.params.type === 'private'
    }
  },
  mounted(){
    this.$client.get('tender/filterOptions').then(({data}) => {
      this.filters.procedureOptions = data.procedure_types
      this.filters.regionOptions = data.regions
      this.filters.organizatorOptions = data.organizators
    })
    this.$client.get('user-filters').then(({data: {data}}) => {
      if(data){
        this.filters.status = data.status;
        this.filters.type = data.type;
        this.filters.region = data.region;
        this.filters.procedure = data.procedure;
        this.filters.organizator = data.organizator;
        this.filters.isElectronic = data.isElectronic;
        this.filters.guaranteed = data.guaranteed;
      }
    })
  },
  computed: {
    isCoordinator(){
       return +this.me.divisions === 2
    },
    me() {
      return this.$store.getters['user/me']
    },
  },
  methods: {
    consoleLog(e){
      console.log(e)
    },
    save() {
      const requestData = {
        status: this.filters.status,
        type: this.filters.type,
        isElectronic: this.filters.isElectronic,
        guaranteed: this.filters.guaranteed,
        procedure: this.filters.procedure,
        region: this.filters.region,
        organizator: this.filters.organizator,
      }
      this.$client.post(`user-filters`, requestData).then(({data}) => {
        console.log(data)
        if(data){
          this.$notify({
            group: 'foo',
            type: 'success',
            text: 'Հաջողությամբ պահպանված է'
          })
        }
      }).catch(e => {
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Էլ. հացեն զբաղված է',
          text: 'Կրկին փորձեք!'
        })
      })
    },
  },
}
</script>
